import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { LanguagesFetchAPI } from '../../api/Languages'
import LoadingAlert from '../../components/Alerts/LoadingAlert'
import { changeLanguage as setAppLanguage } from '../../i18n'

function ModalKioskLanguage({ icon, background, statusLanguage, setStatusLanguage, setAtivity }) {
  const { t } = useTranslation();
  const [showModalLanguage, setShowModalLanguage] = useState(false);
  let token = undefined
  const [languages, setLanguages] = useState([])

  //get languages
  const getLanguages = async () => {
    try {
      const response = await LanguagesFetchAPI.getLanguages(token);
      setLanguages(response.data.languages)
    } catch (err) {
      //console.log(err);
    }
  }

  //change Language: usa i18next (static texts) + persiste en localStorage (usado tambien por el
  //interceptor de axios para pedir los datos dinamicos -productos/categorias/segmentos/promociones- traducidos)
  const changeLanguage = (language) => {
    LoadingAlert(t('language.changing'), t('language.changingSubtitle'));
    setAppLanguage(language);
    setShowModalLanguage(false);

    setTimeout(() => {
      window.location.reload();
    }, 1200);
  }

  const viewLanguages = () => {
    const listItems = languages.map((language) => (
      <div className='m-3' key={language.code}>
        <div className='btn btn-outline-primary  d-block border border-3 rounded-pill p-3 ' onClick={() => changeLanguage(language.code)}>
          <span className='kiosk-subtitle-md  p-3  text-wrap px-3'>{language.name}</span>
        </div>
      </div>
    ));
    return (listItems)
  }

  useEffect(() => {
    getLanguages()
  }, []);
  return (
    <>
      <button className='btn btn-outline-light border-0' onClick={() => (setShowModalLanguage(true))}>
        <i class="uil uil-english-to-chinese"></i>
        <small className='d-block fw-bold'>
          {t('language.label')}
        </small>
      </button>
      <Modal
        centered
        className='modal-dialog-kk'
        size="lg"
        show={showModalLanguage}
        onHide={() => setShowModalLanguage(false)}>
        <Modal.Body >

          <section style={{ backgroundImage: `url(${background})` }} className='kiosk-delivery' onClick={() => setAtivity(1)}>
            <div className='position-relative' >
              <div className='position-absolute start-0  rounded-circle p-1' >
                <i className="uil uil-english-to-chinese display-4 ms-1 text-secondary"></i>
              </div>
            </div>
            <div className='kiosk-delivery_section scale-up-top mt-5'>
              <h2 className='kiosk-text-title-lang text-center'>
                {t('language.modalTitle')}
              </h2>

              {viewLanguages()}

            </div>
            <div className='text-muted text-center'>
              <i className="uil uil-info-circle me-2"></i>
              {t('language.modalSubtitle')}
            </div>
          </section>
        </Modal.Body>

        <div className='d-flex  container-button m-2'>
          <button
            onClick={() => (setShowModalLanguage(false))}
            type="button"
            className={`m-0 btn-lg  shadow-lg border-0 button-ft_1 position-relative `}

            title={t('common.back')}
          >
            <svg xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              viewBox="0 0 24 24"
              className=""
              id="left-arrow">
              <path
                d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z"></path></svg>


          </button>
        </div>

      </Modal>
    </>
  )
}

export default ModalKioskLanguage
